var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9paptsvhaa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3",
    style: {
      fill: "#fff"
    },
    d: "M0 0h25.028v18.556H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    style: {
      clipPath: "url(#9paptsvhaa)"
    },
    transform: "translate(5 9)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M21.514 18.556h-6.4a.5.5 0 0 1-.5-.5v-6.8H10.41v6.8a.5.5 0 0 1-.5.5h-6.4a.5.5 0 0 1-.5-.5V7.669a.5.5 0 1 1 1 0v9.887h5.4v-6.8a.5.5 0 0 1 .5-.5h5.207a.5.5 0 0 1 .5.5v6.8h5.4V7.669a.5.5 0 0 1 1 0v10.387a.5.5 0 0 1-.5.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M24.527 9.6a.5.5 0 0 1-.291-.093l-11.722-8.4L.791 9.51a.5.5 0 0 1-.582-.81L12.223.093a.5.5 0 0 1 .582 0L24.819 8.7a.5.5 0 0 1-.292.907",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.9a5d34ebc4147c0d8ec6ad8f3d4c6626.svg";
export { ForwardRef as ReactComponent };